import { usePage } from 'client/store'
import { getFirstEntityByType } from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BodyInterface } from 'common/types/entities/body-interface'
import React from 'react'
import { LanguageSelector } from '../options'
import CommonWithoutSeoSettingsOld from './CommonWithoutSeoSettings'
import { Affiliate } from './components/affiliate'
import { Background } from './components/background'
import Title from './components/Title'
import Tracking from './components/Tracking'
import { Typography } from './components/typography-new'

interface CommonWithoutSeoSettingsProps {
  isSkipFont?: boolean
  isSkipTitle?: boolean
}

export const CommonWithoutSeoSettingsResolver = ({
  isSkipFont = false,
  isSkipTitle = false,
}: CommonWithoutSeoSettingsProps) => {
  const isMigratedBodyEntity = usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.Body),
  )

  if (isMigratedBodyEntity) {
    return (
      <CommonWithoutSeoSettings
        isSkipFont={isSkipFont}
        isSkipTitle={isSkipTitle}
      />
    )
  }
  return (
    <CommonWithoutSeoSettingsOld
      isSkipFont={isSkipFont}
      isSkipTitle={isSkipTitle}
    />
  )
}

export const CommonWithoutSeoSettings = ({
  isSkipFont,
  isSkipTitle,
}: CommonWithoutSeoSettingsProps) => {
  // @description: for Body
  return (
    <>
      {!isSkipTitle && <Title />}
      <Typography skipFont={isSkipFont} />
      <LanguageSelector />
      <Background<BodyInterface> />
      <Tracking />
      <Affiliate<BodyInterface> />
    </>
  )
}
